import { Heading, Subheading } from "../../../components/catalyst/Heading";

interface ErrorStateProps {
	message: string;
}

export function ErrorState({ message }: ErrorStateProps) {
	return (
		<>
			<Heading>Something went wrong</Heading>
			<Subheading className="text-error">{message}</Subheading>
		</>
	);
}
